<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import FormControlCategoryTitle from '@/common/form-control/FormControlCategoryTitle'

const props = defineProps({
    oldValue: [Array, String],
    newValue: [Array, String],
    categoryComponentId: Number
})

// Pinia Stores
const componentsStore = useComponentsStore()

const component = computed(() => {
    return (componentsStore.items || []).find(o => o.id === props.categoryComponentId)
})

const tableName = computed(() => {
    return component.value?.tableName
})

const oldIds = computed(() => {
    // Support for values provided as ID strings e.g. [x, y, z]
    return typeof props.oldValue === 'string' ? JSON.parse(props.oldValue) : props.oldValue
})

const newIds = computed(() => {
    return typeof props.newValue === 'string' ? JSON.parse(props.newValue) : props.newValue
})
</script>

<template>
    <div class="d-flex align-items-center">
        <div v-if="oldIds?.length">
            <FormControlCategoryTitle v-for="id in oldIds" :key="id" :table-name="tableName" :id="id"
                                      class="d-block mb-1 border rounded py-1 px-2 small"/>
        </div>
        <i v-else class="small">none</i>

        <i class="mx-2 bi-chevron-right"/>

        <div v-if="newIds?.length">
            <FormControlCategoryTitle v-for="id in newIds" :key="id" :table-name="tableName" :id="id"
                                      class="d-block mb-1 border rounded py-1 px-2 small"/>
        </div>
        <i v-else class="small">none</i>
    </div>
</template>